'use strict';

angular.module('lingApp')
  .directive('ripResetPasswordLink', function($window, $document, i18n, RipServer, RipDialog, JsonErrorCode, RipRoute) {
    return {
      template: require('views/rip-reset-password-link.html'),
      restrict: 'E',
      scope: {},
      link: function postLink(scope, element, attrs) {
        scope.submitting = false;
        scope.error = {};
        scope.record = {};

        scope.submit = submit;

        function submit() {
          if (scope.submitting) return;

          if (!validate()) {
            scope.submitting = false;
            return;
          }

          var email = scope.record.email;

          RipServer
            .exec('/rip/login/json/remindPassword?cachebust=' + new Date().getTime(),
                  { email: email,
                    urlLocaleCode: RipRoute.getParam('localeCode') })
            .then(function() {
              RipDialog
                .message({ title: i18n('Note'),
                           template: require('views/rip-dialog-info.html'),
                           bindings: { message: i18n('A reminder email was sent to {0}.', email) }})
                .result(null, function() {
                  var location = $window.location;
                  $window.location.replace(location.protocol
                                           + '//'
                                           + location.host
                                           + '/rip/launch/home'
                                           + location.search);
                });
            }, function(failure) {
              scope.error.message = (failure && failure.message) || null;

              var emailInput = $document[0].getElementById('rip-reset-email');
              emailInput.focus();
              emailInput.select();

              scope.submitting = false;
            });
        }

        function validate() {
          scope.error = {};

          if (!scope.record.email) {
            scope.error.email = i18n('Invalid E-mail address ');
            return false;
          }

          return true;
        }
      }
    };
  });
